import { ROUTES, SCHOOLS_BY_MAJOR_PATH, MAJORS_PATH, SCHOLARSHIPS_PATH, SCHOOLS_PATH } from '@constants/ROUTES';
import { BREADCRUMBS_PAGE_TEXT } from '@constants/breadcrumbs';
import { PAGE_TABS_DATA } from '@constants/scholarships';

import { BreadcrumbsLinks } from '@interfaces/location';

export const getBreadcrumbs = (
  cameFrom: BreadcrumbsLinks[],
  currentPage: string,
  schoolName: string = BREADCRUMBS_PAGE_TEXT.ROOT,
) => ({
  links: [{ to: ROUTES.ROOT, text: schoolName }, ...(cameFrom || [])],
  currentPage,
});

export const getFromMajorLocation = (location: string) => {
  if (location === ROUTES.MAJORS) {
    return {
      from: [{ to: ROUTES.MAJORS, text: BREADCRUMBS_PAGE_TEXT.MAJORS }],
    };
  }

  if (location === ROUTES.FAVORITE_MAJORS) {
    return {
      from: [{ to: ROUTES.FAVORITE_MAJORS, text: BREADCRUMBS_PAGE_TEXT.FAVORITE_MAJORS }],
    };
  }

  return undefined;
};

export const getFromSchoolLocation = (location: string) => {
  if (location === ROUTES.SCHOOLS) {
    return {
      from: [{ to: ROUTES.SCHOOLS, text: BREADCRUMBS_PAGE_TEXT.SCHOOLS }],
    };
  }

  if (location === ROUTES.FAVORITE_SCHOOLS) {
    return {
      from: [{ to: ROUTES.FAVORITE_SCHOOLS, text: BREADCRUMBS_PAGE_TEXT.FAVORITE_SCHOOLS }],
    };
  }

  const majorsRegExp = new RegExp(`^${MAJORS_PATH}/[0-9]+(.[0-9]+)?$`);

  if (location.match(majorsRegExp)) {
    return {
      from: [{ to: location, text: BREADCRUMBS_PAGE_TEXT.MAJOR_DETAILS }],
    };
  }

  const schoolRegExp = new RegExp(`^${SCHOOLS_PATH}/[0-9]+(.[0-9]+)?$`);

  if (location.match(schoolRegExp)) {
    return {
      from: [{ to: location, text: BREADCRUMBS_PAGE_TEXT.SCHOOL_DETAILS }],
    };
  }

  const schoolsByMajorRegExp = new RegExp(`^${SCHOOLS_BY_MAJOR_PATH}/[0-9]+(.[0-9]+)?$`);

  if (location.match(schoolsByMajorRegExp)) {
    return {
      from: [{ to: location, text: BREADCRUMBS_PAGE_TEXT.SCHOOLS_BY_MAJOR }],
    };
  }

  return undefined;
};

export const getFromScholarshipLocation = (location: string) => {
  if (location === `${ROUTES.SCHOLARSHIPS}#${PAGE_TABS_DATA.allScholarships.hash}`) {
    return {
      from: [
        {
          to: `${ROUTES.SCHOLARSHIPS}#${PAGE_TABS_DATA.allScholarships.hash}`,
          text: BREADCRUMBS_PAGE_TEXT.SCHOLARSHIPS,
        },
      ],
    };
  }

  if (location === `${ROUTES.SCHOLARSHIPS}#${PAGE_TABS_DATA.favorites.hash}`) {
    return {
      from: [
        {
          to: `${ROUTES.SCHOLARSHIPS}#${PAGE_TABS_DATA.favorites.hash}`,
          text: BREADCRUMBS_PAGE_TEXT.SCHOLARSHIPS,
        },
      ],
    };
  }

  if (location === `${ROUTES.SCHOLARSHIPS}#${PAGE_TABS_DATA.myApplications.hash}`) {
    return {
      from: [
        {
          to: `${ROUTES.SCHOLARSHIPS}#${PAGE_TABS_DATA.myApplications.hash}`,
          text: BREADCRUMBS_PAGE_TEXT.SCHOLARSHIPS,
        },
      ],
    };
  }

  const scholarshipsRegExp = new RegExp(`^${SCHOLARSHIPS_PATH}/[0-9]+(.[0-9]+)?$`);

  if (location.match(scholarshipsRegExp)) {
    return {
      from: [{ to: location, text: BREADCRUMBS_PAGE_TEXT.SCHOLARSHIP_DETAILS }],
    };
  }

  const schoolRegExp = new RegExp(`^${SCHOOLS_PATH}/[0-9]+(.[0-9]+)?$`);

  if (location.match(schoolRegExp)) {
    return {
      from: [{ to: location, text: BREADCRUMBS_PAGE_TEXT.SCHOOL_DETAILS }],
    };
  }

  return undefined;
};
